<template>
  <div class="container-fluid" v-if="auth == 'loggedin' || token != null || token != undefined">
    <b-card
      header="Anyag + kivitel"
      border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      class="text-center mt-2"
    >

      <div class="row">
        <div class="col-sm-12 mx-auto">

          <div class="col-sm-12">
            <div class="row">

              <div class="col-sm-2">
                <!-- // NEW -->
                <b-button
                  size="sm"
                  class="btn float-left"
                  variant="primary"
                  @click="$router.push({name: 'AnyagtipusokNew'})"
                  ><b-icon-plus-circle></b-icon-plus-circle>
                  Új anyag
                </b-button>
              </div>

              <div class="col-sm-2">
                <!-- // EXCEL EXPORT-->
                <b-button
                  size="sm"
                  class="btn float-right"
                  variant="warning"
                  @click="tableToExcel('table', 'Anyagtípusok')"
                  ><b-icon-download></b-icon-download>
                  Excel export
                </b-button>
              </div>

              <div class="col-sm-4">
                <!-- // EMPTY FILTER -->
                <b-button
                  size="sm"
                  class="btn float-right"
                  variant="primary"
                  @click="partnerkategoriaSelected='K0', loadList()"
                  ><b-icon-x-circle></b-icon-x-circle>
                  Szűrő törlése
                </b-button>
              </div>

              <!-- // FILTER SELECT-->
              <div class="col-sm-4">
                <b-form-select
                  size="sm"
                  v-model="partnerkategoriaSelected"
                  @change=loadList()
                  :options="partnerkategoria"
                  class="form-control"
                  id="kategoria"
                ></b-form-select>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <table ref="listTable" class="labelsize table-striped text-right">
              <thead>
                <tr>
                <th>Látható</th>
                <th>edit</th>
                <th>id</th> 
                <th class="text-left">Anyag+kivitel</th>
                <th class="text-left">Megnevezés</th>
                <th class="text-left">Leírás</th>
                <th>Kat</th>
                <th>Mindíj</th>
                <th>0.124 m2 alatt</th>
                <th>0.125 - 0.249 m2</th>
                <th>0.250 - 0.499 m2</th>
                <th>0.500 - 0.749 m2</th>
                <th>0.750 - 0.999 m2</th>
                <th>1.000 - 2.499 m2</th>
                <th>2.500 - 4.999 m2</th>
                <th>5.000 - 9.999 m2</th>
                <th>10.000 - 19.999 m2</th>
                <th>20.000 m2 fölött</th>
                <th>del</th>
                </tr>
              </thead>
              <tbody is="draggable" group="people" @end="onEnd" :list="list" tag="tbody">
                <tr  v-for="(element, index) in list" :key="element.id" @click="rowcolored(index)" :class="{'highlight': (index == selectedUser)}" >
                  <td class="text-left">
                    <b-form-checkbox v-model="element.hidden" switch size="sm" @change="radioOn(element)"></b-form-checkbox>
                  </td>
                  <td>
                    <b-button 
                      id="kompaktInput"               
                      type="button" 
                      variant="outline-success"
                      @click="$router.push({name: 'AnyagtipusokNew', params:{id: element.id}})"
                      ><b-icon-pencil></b-icon-pencil>
                    </b-button>
                  </td>
                  <td><p>{{element.id}}</p></td>
                  <td><p class="nowrap1">{{element.tipus}}</p></td>
                  <td><p class="nowrap2">{{element.megnevezes}}</p></td>
                  <td><p class="nowrap3">{{element.leiras}}</p></td>
                  <td><p >{{element.kategoria}}</p></td>
                  <td>
                    <p hidden>{{element.minimaldij}}</p>
                    <input type="number" v-model="element.minimaldij" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <p hidden>{{element.ar1}}</p>
                    <input type="number" v-model="element.ar1" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <p hidden>{{element.ar2}}</p>
                    <input type="number" v-model="element.ar2" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <p hidden>{{element.ar3}}</p>
                    <input type="number" v-model="element.ar3" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <p hidden>{{element.ar4}}</p>
                    <input type="number" v-model="element.ar4" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <p hidden>{{element.ar5}}</p>
                    <input type="number" v-model="element.ar5" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <p hidden>{{element.ar6}}</p>
                    <input type="number" v-model="element.ar6" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <p hidden>{{element.ar7}}</p>
                    <input type="number" v-model="element.ar7" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <p hidden>{{element.ar8}}</p>
                    <input type="number" v-model="element.ar8" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <p hidden>{{element.ar9}}</p>
                    <input type="number" v-model="element.ar9" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <p hidden>{{element.ar10}}</p>
                    <input type="number" v-model="element.ar10" @blur="changeElement({data: element})"/>
                  </td>
                  <td>
                    <b-button
                      id="kompaktInput"               
                      @click="showMsgBoxTwo(element.id)"
                      variant="outline-danger"
                      class="mr-1"
                      ><b-icon-trash></b-icon-trash>
                    </b-button>                      
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
    </b-card>
    <div class="labelsize">
      <p></p>
      <h4>Számolási logika</h4>
      <p></p>
      <p> Ha az (osszterulet >= 0 és <= 0.124 akkor ar = ar1 * osszterulet</p>
      <p> Ha az (osszterulet >= 0.125 és <= 0.249 akkor ar = ar2 * osszterulet </p>
      <p> Ha az (osszterulet >= 0.250 és <= 0.499 akkor ar = ar3 * osszterulet </p>
      <p> Ha az (osszterulet >= 0.500 és <= 0.749 akkor ar = ar4 * osszterulet </p>
      <p> Ha az (osszterulet >= 0.750 és <= 0.999 akkor ar = ar5 * osszterulet </p>
      <p> Ha az (osszterulet >= 1.000 és <= 2.499 akkor ar = ar6 * osszterulet </p>
      <p> Ha az (osszterulet >= 2.500 és <= 4.999 akkor ar = ar7 * osszterulet </p>
      <p> Ha az (osszterulet >= 5.000 és <= 9.999 akkor ar = ar8 * osszterulet </p>
      <p> Ha az (osszterulet >= 10.000 és <= 19.999 akkor ar = ar9 * osszterulet </p>
      <p> Ha az (osszterulet >= 20.000 akkor ar = ar10 * osszterulet </p>
      <p> Ha az (osszterulet * ar(x) <= minimaldij akkor ar = minimaldij</p>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'
import draggable from 'vuedraggable'

export default {
  components: {
          draggable,
  },
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      selectedUser: null,
      boxTwo: '',
      token: localStorage.usertoken,
      auth: '',
      userType : decoded.usertype,
      search: '',
      partnerkategoriaSelected: 'K0',
      partnerkategoria: [
        { value: 'K0', text: 'Válassz kategóriát!' },
        { value: 'A1', text: 'A1' },
        { value: 'VEA', text: 'VEA' },
        { value: 'BID', text: 'BID' },
        { value: 'TD', text: 'TD' },
        { value: 'K5', text: 'K5' },
        { value: 'K6', text: 'K6' },
        { value: 'K7', text: 'K7' },
        { value: 'K8', text: 'K8' },
        { value: 'K9', text: 'K9' },
        { value: 'K10', text: 'K10' }
      ],
      list: [],
      uri: 'data:application/vnd.ms-excel;base64,',
      template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urns:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function (s) { return window.btoa(unescape(encodeURIComponent(s))) },
      format: function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p] }) }
    }
  },
  methods: {
    rowcolored: function(el) {
      this.selectedUser = el;
      console.log(el)
    },
    radioOn: function(el) {
      let id = el.id
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.id = id
        if(el.hidden== true){
          payload.hidden = 0
        } else {
          payload.hidden = 1
        }
        payload.tipus = el.tipus
        payload.kategoria = el.kategoria
        payload.megnevezes = el.megnevezes
        payload.leiras = el.leiras
        payload.minimaldij = el.minimaldij
        payload.ar1 = el.ar1
        payload.ar2 = el.ar2
        payload.ar3 = el.ar3
        payload.ar4 = el.ar4
        payload.ar5 = el.ar5
        payload.ar6 = el.ar6
        payload.ar7 = el.ar7
        payload.ar8 = el.ar8
        payload.ar9 = el.ar9
        payload.ar10 = el.ar10
        payload.token = this.token
        payload.userType = this.userType
        axios
          .post(process.env.ROOT_API+'/anyagtipus/save', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }      
    },    
    onEnd: function(evt) { 
      for(let el in this.list) {
        this.list[el].order = el
      }
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.list = this.list
        axios
          .post(process.env.ROOT_API+'/anyagtipus/ordersave', { payload })
          .then(res => {
            //this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    changeElement: function (data) {
      let payload = data.data

      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        axios.post(process.env.ROOT_API+'/anyagtipus/save', { payload })
          .then((res) => {
          }).catch((err) => {
            console.log(err)
          })
      }
    },
    deleteElement: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios
          .post(process.env.ROOT_API+'/anyagtipus/delete', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showMsgBoxTwo (reqData) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Biztos, hogy törölni akarod? ', {
          title: 'Megerősítés',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.deleteElement(reqData)
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        this.selectedUser = null
        payload.token = this.token
        payload.userType = this.userType
        payload.filter = this.partnerkategoriaSelected
        axios.post(process.env.ROOT_API+'/anyagtipus/getlist', { payload })
          .then((res) => {
            this.list = res.data
            for(let el in this.list) {
              if (this.list[el].hidden == 0) {
              this.list[el].hidden = false
              } else {
              this.list[el].hidden = true
              }
            }
          }).catch((err) => {
            console.log(err)
          })
      }
    },
    tableToExcel (table, name) {
      if (!table.nodeType) table = this.$refs.listTable
      var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
      var link = document.createElement('a')
      link.download = 'Anyagtipusok.xls'
      link.href = this.uri + this.base64(this.format(this.template, ctx))
      link.click()
    }
  },
  mounted: function () {
    this.loadList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Anyagtipusok.vue